/**
 * Vacinas exigidas por empresa e unidade (#530): a empresa escolhe, a unidade soma.
 */
import apiClient from './apiClient';
import type { ExigenciasDaEmpresa, GravacaoDeExigencias } from '../types/vaccination';

const VAZIO: ExigenciasDaEmpresa = { empresa: [], unidades: [] };

class VaccineRequirementService {
  async get(companyId: string): Promise<ExigenciasDaEmpresa> {
    const response = await apiClient.get<ExigenciasDaEmpresa>(
      `/companies/${companyId}/vaccine-requirements`
    );
    return response.data ?? VAZIO;
  }

  async replace(companyId: string, data: GravacaoDeExigencias): Promise<ExigenciasDaEmpresa> {
    const response = await apiClient.put<ExigenciasDaEmpresa>(
      `/companies/${companyId}/vaccine-requirements`,
      data
    );
    return response.data ?? VAZIO;
  }
}

export const vaccineRequirementService = new VaccineRequirementService();
export default vaccineRequirementService;
